<template>
	<div class="sdk_initaial">
		<document-title-bar :pathData="isPathData"></document-title-bar>
		<h1 class="doc_main_h1">视频人脸检测与跟踪初始化</h1>
		<h3 class="doc_main_h3">功能描述</h3>
		<p class="doc_main_p">
			该接口为视频人脸检测与跟踪进行初始化。
		</p>
		<h3 class="doc_main_h3">函数</h3>
		<pre class="doc_main_pre"><code class="doc_main_code">bool __stdcall SKFaceVideoTrackInit(int nWidth, int nHeight, int nModel, bool bStrangerMemory);</code></pre>
        <h3 class="doc_main_h3">参数</h3>
        <p class="doc_main_p">（1）nWidth: 视频流数据宽度</p>
        <p class="doc_main_p">（2）nHeight: 视频流数据宽度</p>
        <p class="doc_main_p">（3）nModel: 数据模式</p>
        <p class="doc_main_p indent_left_80">参数为0（init）：基本模式。包含：人脸位置，人脸姿态（Yaw,Pitch,Roll）;</p>
        <p class="doc_main_p indent_left_80">参数为1（init）：基本模式、人脸属性（名字、性别、生日、备注信息）;</p>
        <p class="doc_main_p indent_left_80">参数为2（init）：基本模式、人脸72关键点;</p>
        <p class="doc_main_p indent_left_80">参数为3（init）：基本模式、人脸属性、人脸72个关键点）;</p>
        <p class="doc_main_p">（4）bStrangerShortMemory：详见短时记忆功能</p>
        <h3 class="doc_main_h3">返回值</h3>
        <p class="doc_main_p">bool类型，视频初始化结果，成功为true，失败为false，成功后则可以调用视频人脸检测与跟踪。
		</p>
		<h3 class="doc_main_h3">示例代码</h3>
		<pre class="doc_main_pre"><code class="doc_main_code">bool bVideoTrackInit = SKFaceVideoTrackInit(1920, 1080, 0, false);</code></pre>
	</div>
</template>
<script>
	import DocumentTitleBar from '../../../../components/documentTitleBar';
	export default{
		components:{
			'document-title-bar':DocumentTitleBar,
		},
		data(){
			return{
				isPathData:['人脸识别','SKFace-Windows','基础接口','视频人脸检测与跟踪初始化'],
			}
		},
		watch:{

		},
		methods:{

		},
		mounted(){

		}
	}
</script>
<style lang="less" rel="stylesheet/less">
	@import '../../../../less/index.less';
	.sdk_initaial{
	}
</style>	



// WEBPACK FOOTER //
// src/views/documents/skfacewindows/basics/faceInitial.vue